var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWithdraw(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1728_5495)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.0015 0.846313L8.53996 3.15401H7.77073V4.69247H6.23227V3.15401H5.46304L7.0015 0.846313ZM12.3861 6.23093V12.3848H1.61689V6.23093H12.3861ZM13.1553 5.4617H0.847656V13.154H13.1553V5.4617Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.0021 7.00006C7.30515 7.00006 7.60524 7.05975 7.88522 7.17572C8.1652 7.2917 8.4196 7.46168 8.63389 7.67597C8.84818 7.89026 9.01816 8.14466 9.13413 8.42464C9.25011 8.70462 9.3098 9.0047 9.3098 9.30775C9.3098 9.6108 9.25011 9.91089 9.13413 10.1909C9.01816 10.4709 8.84818 10.7252 8.63389 10.9395C8.4196 11.1538 8.1652 11.3238 7.88522 11.4398C7.60524 11.5558 7.30515 11.6154 7.0021 11.6154H10.8483V10.8462H11.6175V7.76929H10.8483V7.00006H7.0021ZM4.69441 9.30775C4.69441 8.69572 4.93754 8.10874 5.37032 7.67597C5.8031 7.24319 6.39007 7.00006 7.0021 7.00006H3.15595V7.76929H2.38672V10.8462H3.15595V11.6154H7.0021C6.39007 11.6154 5.8031 11.3723 5.37032 10.9395C4.93754 10.5068 4.69441 9.91979 4.69441 9.30775Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1728_5495"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12.3077,
    height: 12.3077,
    fill: "white",
    transform: "translate(0.847656 0.84613)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWithdraw);
export default __webpack_public_path__ + "static/media/withdraw.34e3752d8eb22b399a2f9f1c3ead04ef.svg";
export { ForwardRef as ReactComponent };